import reduce from 'lodash/reduce'
import uniq from 'lodash/uniq'
import actionTypes from 'constants/actionTypes'
import { selectUsers } from 'selectors/users'
import type { RootState } from 'types/state'
import type { UserMap } from 'types/domain'
import type { ActionShape, DispatchFn, GetStateFn } from 'types/adapters'

type Dispatch = DispatchFn<ActionShape>
type GetState = GetStateFn

const selectUsersWithParams = selectUsers as unknown as (state: RootState, props: { params: { ids: string[] } }) => UserMap


export const usersSearch = ({ search }: { search: string }) => {
  return {
    type: actionTypes.USERS.SEARCH,
    payload: { search },
    meta: {
      client: 'auth',
      request: 'users.search'
    }
  }
}

export const clearUsersSearch = () => {
  return {
    type: actionTypes.USERS.SEARCH.CLEAR
  }
}

export const getUsers = ({ ids }: { ids: string[] }) => {
  return (dispatch: Dispatch, getState: GetState) => {
    const users = selectUsersWithParams(getState() as RootState, {
      params: { ids }
    })

    const invalid = reduce(
      ids,
      (us: string[], id: string) => {
        const u = (users as UserMap)[id]
        if (!u || u.updated == null || u.updated < Date.now() - 5000) {
          us.push(id)
        }
        return us
      },
      [] as string[]
    )

    if (!invalid.length) {
      return
    }

    return dispatch({
      type: actionTypes.USERS.GET,
      payload: {
        ids: uniq(invalid)
      },
      meta: {
        client: 'auth',
        request: 'users.get'
      }
    })
  }
}
